<template>
  <a-modal
    v-model="mainVisible"
    width="650px"
    class="modal"
    :maskClosable ="false"
    @cancel="handleCancel"
    footer=""

  >
  <div slot="title" class="tip-icon"> {{title}} </div>
    <div class="message">
          <div class="content" ref="ruleForm" :model="content">
            <div class="one-line">
              <div>诊疗时间：</div>
              <div>{{ content.treatmentTime }}</div>
            </div>
            <div class="one-line">
              <div>诊疗场所：</div>
              <div>{{ content.recordType | DictionaryFilter('DOSSIER_TYPE') }}</div>
            </div>
            <div class="one-line">
              <div>病历照片：</div>
              <div>
                <span v-for="item in this.attachments" :key="item.id">
                <img
                  v-if="item.fileUrl != null"
                  style="width: 100px; height: 100px; margin-right: 10px; margin-top:10px;padding: 5px; border:1px solid #d9d9d9;margin-bottom: 10px;" 
                  :src="url + item.id"
                  @click="handleImg(item.id)"
                />
              </span></div>
            </div>
            <div class="one-line">
              <div>查验报告：</div>
              <div><span v-for="item in this.attachments1" :key="item.id">
                <img
                  v-if="item.fileUrl != null "
                  style="width: 100px; height: 100px; margin-right: 10px; padding: 5px; border:1px solid #d9d9d9;margin-top:10px;margin-bottom: 10px;" 
                  :src="url + item.id"
                  @click="handleImg(item.id)"
                />
              </span></div>
            </div>
          </div>
        </div>
        <!-- 放大图片 -->
        <a-modal
          :visible="previewVisible"
          :footer="null"
          @cancel="handleCancelImg"
          class="imgBox"
        >
          <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
  </a-modal>
</template>

<script>
import {
  queryByIdMed,
  queryFileBatch
} from "@/api/api.js"
import { DictionaryService } from '@common/services/dictionary.service'
import upload from "@/components/upload/upload.vue";
export default {
  components: { upload },
  name: "addModalMed",
  props: ["visible", "userData", "title"],
  data() {
    return {
      mainVisible:this.visible,
      url:process.env.VUE_APP_PROXY + "base/file/download-file?id=",
      //图片列表
      attachments: [],
      attachments1:[],
      id:'',
      //参数
      content: {
        mainReport: "",
        record: "",
        recordType: "",
        treatmentTime: undefined,
        id: '',
        imgSts:'1'
      },
      disabled: false,
      usrRTList: [],
      imgSts :'',
      previewVisible: false,
      previewImage: "",
      bigurl: "",
    };
  },
  created() {

      //查询数据
      queryByIdMed({id:this.userData.id}).then((res) => {
        this.content.treatmentTime = res.content.treatmentTime
        this.content.recordType = res.content.recordType
        this.content.record = res.content.record
        this.content.mainReport = res.content.mainReport
      })

      //查询图片列表
      if (null != this.userData.id) {
        queryFileBatch({ busId: this.userData.record }).then((res) => {
            res.content.forEach((item) => {
              this.attachments.push({
                fileUrl: item.fileUrl,
                id: item.id,
                busId:item.busId,
            })
          });
        })
      }

      //查询图片列表
      if (null != this.userData.mainReport) {
        queryFileBatch({ busId: this.userData.mainReport }).then((res) => {
            res.content.forEach((item) => {
              this.attachments1.push({
                fileUrl: item.fileUrl,
                id: item.id,
                busId:item.busId,
            })
          });
        })  
      }

  },
  mounted() {
      //查询数据字典
      DictionaryService.getAllNeedDic(["DOSSIER_TYPE"]).then((res) => {
        this.usrRTList = DictionaryService.getOptions("DOSSIER_TYPE");
      });
  },
  methods: {
    /* 表格图片查看 */
    handleImg(file) {
      this.previewVisible = true;
      this.bigurl = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
      this.previewImage = this.bigurl + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },
    success(title) {
      //提示
      this.$message.success(title, 3);
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.message {
  width: 100%;
  height: auto;
  
  .ant-form-item{
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label{
    width: 120px;
  }
  /deep/ .ant-form-item-control{
    width: 350px;
  }
  /deep/ .input-number-order{
    width: 350px;
  }

  /deep/ .imgBox{
    width: 300px;
  }
}

.content {
    width: 100%;
    border: 1px solid #dcdcdc;
    border-bottom: none;
    display: flex;
    flex-wrap: wrap;
    align-content: baseline;
    > div {
      width: 50%;
      border-bottom: 1px solid #dcdcdc;
      display: flex;
      line-height: 50px;
      > div:first-child {
        width: 120px;
        text-align: right;
        padding-right: 5px;
        border-right: 1px solid #dcdcdc;
        background-color: #F2F2F7;
      }
      > div:last-child {
        flex: 1;
        padding-left: 10px;
      }
    }
    .one-line {
      width: 100%;
      > div:first-child {
        width: 120px;
      }
      > div:last-child {
        flex: 1;
      }
    }
  }
</style>